import * as React from 'react';
import { Ref, forwardRef } from 'react';
interface SVGRProps {
  color?: string;
  height?: string;
  width?: string;
  title?: string;
  titleId?: string;
}
const SvgMoveRight = (
  { color = 'currentColor', height = '24px', width = '24px', title, titleId }: SVGRProps,
  ref: Ref<SVGSVGElement>,
): JSX.Element => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    ref={ref}
    aria-labelledby={titleId}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      d="M20 5h2v14h-2V5ZM2 13h11.586l-5.293 5.293 1.414 1.414L17.414 12 9.707 4.293 8.293 5.707 13.586 11H2v2Z"
      fill={color}
    />
  </svg>
);
const ForwardRef = forwardRef(SvgMoveRight);
export default ForwardRef;
